import React from 'react';

import {
  Grid,
  Button,
} from '@material-ui/core';
import NextIcon from '@material-ui/icons/ChevronRight';
import PrevIcon from '@material-ui/icons/ChevronLeft';

import InputField from '../../common/components/inputField';
import * as asyncSelectData from '../../common/asyncSelectData';

import classes from '../../css/getCSS';


const lifestyleInfoForm = (props) => {
  let buttons = (
    <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
      Update
    </Button>
  );

  if (!props.editMode) {
    buttons = (
      <React.Fragment>
        <Button onClick={() => props.redirectToStep(props.prevStep)} variant="contained" color="primary" size="large" className={classes.Button} style={{ marginRight: '10px' }}>
          <PrevIcon />
          Back
        </Button>
        <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
          Next
          <NextIcon />
        </Button>
      </React.Fragment>
    );
  }

  let blockquote = null;

  if (!props.editMode) {
    blockquote = (
      <React.Fragment>
        <blockquote className={classes.profileFormQuote}>
          Tell us more about your lifestyle.
        </blockquote>
        <br /><br />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {blockquote}
      <Grid container spacing={24}>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="body_type"
            config={props.inputs.body_type}
            changed={event => props.inputChangedHandler(event, 'body_type')}
            loadOptions={() => asyncSelectData.getOptionConstants('body_type')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="physical_disabilities"
            config={props.inputs.physical_disabilities}
            changed={event => props.inputChangedHandler(event, 'physical_disabilities')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="diet"
            config={props.inputs.diet}
            changed={event => props.inputChangedHandler(event, 'diet')}
            loadOptions={() => asyncSelectData.getOptionConstants('diet')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="smoke"
            config={props.inputs.smoke}
            changed={event => props.inputChangedHandler(event, 'smoke')}
            loadOptions={() => asyncSelectData.getOptionConstants('smoke')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="drink"
            config={props.inputs.drink}
            changed={event => props.inputChangedHandler(event, 'drink')}
            loadOptions={() => asyncSelectData.getOptionConstants('drink')}
          />
        </Grid>
      </Grid>
      <br />
      {buttons}
    </React.Fragment>
  );
};

export default lifestyleInfoForm;



// WEBPACK FOOTER //
// ./src/profile/components/LifestyleInfoForm.js